
import { Check, CheckButton, Copy, Flex } from '@elparking/components'
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled(Flex)`
    border-radius: 50px;
`

Container.propTypes = {
    checked: PropTypes.bool,
}

export const VehicleTypeCard = ({icon: Icon, label, checked, onChange, keyId, isLoading}) => {
    const labelComponent = <Container alignItems='center' checked={checked} flexDirection='row' width='auto' height='auto' justifyContent='space-between' padding='8px'>
        <Icon height='18px' color={checked ? 'accent_dark70' : 'black'} />
        <Copy padding='0px' fontColor={checked ? 'accent_dark70' : 'inherit'} fontWeight={checked ? 'book' : 'regular'} fontSize='small'>{label}</Copy>
    </Container>
    return <Check
      checkButtonElement={CheckButton.labelInside}
      labelComponent={labelComponent}
      width='auto'
      height='auto'
      onChange={onChange}
      checked={checked}
      id={`vehicle-type-${keyId}`}
      name={keyId}
      type='checkbox'
      borderWidth='1px'
      borderRadius='50px'
      marginRight='8px'
      fontColor={checked ? 'accent_dark70' : 'gray'}
      borderColor={checked ? 'accent_dark70' : 'gray20'}
      backgroundColor={checked ? 'accent10' : 'white'}
      disabled={isLoading}
    />
}
VehicleTypeCard.defaultProps = {
    checked: false,
    isLoading: false,
}

VehicleTypeCard.propTypes = {
    icon: PropTypes.object,
    label: PropTypes.node,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    keyId: PropTypes.string,
    isLoading: PropTypes.bool,
}

export default VehicleTypeCard
